export default __webpack_public_path__ + "static/media/15_1.511b42c5.jpg";